import { createFileRoute } from '@tanstack/react-router'
import { RiskMatrixSettingsPage } from '@/features/compliance-registers/risks/matrix-settings'
import { requireActiveSubscription } from '@/lib/middleware'

export const Route = createFileRoute('/_authenticated/_organization/compliance/risks_/settings')({
  beforeLoad: async () => requireActiveSubscription(),
  component: RiskMatrixSettingsPage,
})
